/**
 * @file コンポーネント：リストトグルアイテム DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledItem,
    StyledItemChildrenlist,
    StyledItemChildrenlistItem,
    StyledItemChildrenlistItemAnchor,
    StyledItemToggle,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledItem>
            <StyledItemToggle
                className={props.isOpen === true ? "is-open" : ""}
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    props.setIsOpen(!props.isOpen);
                }}
            >
                {props.text}
            </StyledItemToggle>
            <StyledItemChildrenlist
                className={props.isOpen === true ? "is-open" : ""}
            >
                {props.children.map((child, index) => (
                    <StyledItemChildrenlistItem key={"child-" + index}>
                        <StyledItemChildrenlistItemAnchor
                            className={child.isActive ? "is-active" : ""}
                            href={child.href}
                        >
                            {child.text}
                        </StyledItemChildrenlistItemAnchor>
                    </StyledItemChildrenlistItem>
                ))}
            </StyledItemChildrenlist>
        </StyledItem>
    );
};
